import { useState } from 'react';

import styled from 'styled-components';
import { buttonBaseStyle } from '@/styles/constant';
import { Button, MenuItem, Select, Typography } from '@mui/material';

import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

interface Props {
  lan: string;
}

const Layout = styled.div`
  padding: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export default function PopupSetLang({ lan }: Props) {
  const { t } = useTranslation();

  const [language, setLanguage] = useState(lan);

  const handleCloseClick = () => {
    i18next.changeLanguage(language);
    window.alert(t('Settings.message.willRefresh'));
    window.location.reload();
  };

  return (
    <Layout>
      <Select id="Language" fullWidth={true} value={language} onChange={(e) => setLanguage(e.target.value)}>
        <MenuItem value="ko-KR">한국어</MenuItem>
        <MenuItem value="en-US">English</MenuItem>
      </Select>
      <Button
        variant="contained"
        sx={{
          ...buttonBaseStyle,
          width: 300,
          height: 44,
          borderRadius: 22,
        }}
        color="info"
        onClick={handleCloseClick}
      >
        <Typography fontWeight="medium">{t('Common.label.registButton')}</Typography>
      </Button>
    </Layout>
  );
}
